import { Action, createReducer, on } from '@ngrx/store';
import * as fromPaymentsAndStatementsActions from '../actions';

export const cutOffDaysForChangeKey = 'cutOffDaysForChange';

export interface State {
  loaded: boolean;
  error?: Error | any;
  day: string;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  day: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromPaymentsAndStatementsActions.loadCutOffDayForChange, fromPaymentsAndStatementsActions.saveCutOffDaysForChange, state => state),
  on(fromPaymentsAndStatementsActions.loadCutOffDayForChangeSuccess, (state, action) => ({ ...state, day: action.response, loaded: true })),

  on(
    fromPaymentsAndStatementsActions.loadCutOffDayForChangeFailure,
    fromPaymentsAndStatementsActions.saveCutOffDaysForChangeFailure,
    (state, { error }) => ({
      ...state,
      error
    })
  )
);

export const selectCutOffDayForChange = (state: State) => state.day;
export const selectCutOffDayForChangeLoaded = (state: State) => state.loaded;
export const selectCutOffDayForChangeError = (state: State) => state.error;
